const fill_16 = require("./fill_16.svg");
const red_16 = require("./red_16.svg");

export const Delete = {
  Fill: {
    16: fill_16,
    red_16: red_16,
  },
};
